import React, { useEffect, useState, useRef } from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip
} from '@mui/material';
import "../../../styles/Auth/purchase.css";
import { DateTime } from "luxon";
import { Box, Modal, Button, Menu, MenuItem } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import { postData, getData, putData, deleteData } from '../../../webService/webservice.js';
import TVFMLoader from "../Loader/loader.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import ProductSelect from "../../Challange/ProductSelect.jsx";
import AddProductForm from "../Product/AddProductForm.jsx";
import SupplierSelect from "../../Challange/SupplierSelect.jsx";
import AddSupplierForm from "../Suppliers/AddSupplierForm.jsx";
import { saveAs } from "file-saver";
import { useStore } from "../../../Context/context.jsx";
import PurchaseHeader from "./purchase-header.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
const PurchasePage = ({ filters }) => {
    const EMPTY_ARRAY = [];
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const bulkUploadRef = useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (event) => {
        setActionAnchorEl(event.currentTarget);
    };
    const handleActionClose = () => {
        setActionAnchorEl(null);
    };
    const initialStoreId = adminStoreIds[0] || "";
    const token = localStorage.getItem("Token");
    const [isAddPurchase, setIsAddPurchase] = useState(false);
    const [isAddStore, setIsAddStore] = useState(false);
    const [isAddProduct, setIsAddProduct] = useState(false);
    const [productRefreshKey, setProductRefreshKey] = useState(0);
    const [storeRefreshKey, setStoreRefreshKey] = useState(0);
    const [supplierRefreshKey, setSupplierRefreshKey] = useState(0);
    const [isAddSupplier, setIsAddSupplier] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showFilter, setShowFilter] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [purchases, setPurchases] = useState([]);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Date',
        'Supplier',
        'Product Count',
        'Grand Total',
        'Paid',
        'Due',
        'Payment Status',
        'Action',
    ];
    const [isEditMode, setIsEditMode] = useState(false);
    const [editPurchaseId, setEditpurchaseId] = useState(null);
    const [open, setOpen] = useState(false);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(5);
    const [PurchaseToDelete, setPurchaseToDelete] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [products, setProducts] = useState([]);
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isViewLogsPopup, setIsViewLogsPopup] = useState(false); // NEW
    const [viewLogsData, setViewLogsData] = useState(null); // NEW
    const [isViewPurchasePopup, setIsViewPurchasePopup] = useState(false); // NEW
    const [viewPurchaseData, setViewPurchaseData] = useState(null); // NEW
    const sort = [[sortField, sortOrder]];
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const sessionToken = localStorage.getItem("Token");
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const handleClose = () => {
        setOpen(false);
        setPurchaseToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleOpen = (purchaseId) => {
        setPurchaseToDelete(purchaseId);
        setOpen(true);
    };



    const handleViewLogs = async (purchaseId) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(`purchase/purchase/${purchaseId}`, {}, token);
            if (res?.data) {
                setViewLogsData(res.data);
                setIsViewLogsPopup(true);
            }
        } catch (error) {
            console.error("View Logs Error:", error);
            toast.error("Failed to load payment logs");
        }
    };

    const handleViewPurchase = async (purchaseId) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(`purchase/purchase/${purchaseId}`, {}, token);
            if (res?.data) {
                setViewPurchaseData(res.data);
                setIsViewPurchasePopup(true);
            }
        } catch (error) {
            console.error("View Purchase Error:", error);
            toast.error("Failed to load purchase details");
        }
    };


    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const [formData, setFormData] = useState({
        purchaseType: "Product",
        products: [], // Array of product objects
        purchaseDate: "",
        supplierId: "",
        supplierName: "",
        supplierPhoneNumber: "",
        supplierEmailAddress: "",
        grandTotal: "",
        paidAmount: "",
        payments: [{ method: "", amount: "" }],
        existingPayments: [], // NEW: to track historical logs
        supplierInvoiceNumber: "",
        storeId: initialStoreId,
        subtotal: "",
        gstPercentage: 0,
        purchaseGST: 0
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            if (formData.storeId && !formData.storeName) {
                try {

                    const sid = Array.isArray(formData.storeId) ? formData.storeId[0] : formData.storeId;
                    if (!sid) return;

                    const res = await getData(`stores/store/${sid}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId]);

    const handleAddPurchase = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            toast.error("Please fill all required fields correctly.");
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            // Build products array from formData.products

            const totals = formData.purchaseType === "Product"
                ? calculatePurchaseTotals(formData.products)
                : {
                    subtotal: Number(formData.subtotal || 0),
                    totalGST: Number(formData.purchaseGST || 0),
                    grandTotal: Number(formData.grandTotal || 0),
                    products: []
                };

            const purchaseData = {
                storeId: formData.storeId,
                purchaseDate: formData.purchaseDate,
                supplierId: formData.supplierId,        // ✅ ObjectId
                supplierName: formData.supplierName,
                purchaseType: formData.purchaseType,
                products: totals.products.map(p => ({
                    productId: p.productId,
                    qty: Number(p.qty),
                    purchasePrice: Number(p.purchasePrice),
                    mrp: Number(p.mrp || 0),
                    gstPercentage: Number(p.gstPercentage),
                    gstAmount: Number(p.gstAmount)
                })),

                totalPurchaseAmount: totals.subtotal,
                purchaseGST: totals.totalGST,
                grandTotal: totals.grandTotal,
                payments: formData.payments.filter(p => p.method && p.amount).map(p => ({
                    method: p.method,
                    amount: Number(p.amount)
                })),
                paidAmount: formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0),

                supplierEmailAddress: formData.supplierEmailAddress,
                supplierPhoneNumber: formData.supplierPhoneNumber,
                supplierInvoiceNumber: formData.supplierInvoiceNumber
            };



            console.log("Sending Purchase data:", purchaseData);

            const response = await postData("purchase/", purchaseData, token);

            toast.success(response.message || "Purchase added successfully");

            setFormData({
                purchaseType: "Product",
                products: [],
                purchaseDate: "",
                supplier: "",
                supplierPhoneNumber: "",
                supplierEmailAddress: "",
                grandTotal: "",
                paidAmount: "",
                payments: [{ method: "", amount: "" }],
                storeId: initialStoreId,
                supplierInvoiceNumber: "",
                subtotal: "",
                gstPercentage: 0,
                purchaseGST: 0,
            });
            setIsAddPurchase(false);
            triggerRefresh();
            fetchPurchase();

        } catch (error) {
            console.error("Add Purchase Error:", error);
            toast.error(error?.response?.data?.message || "Add Purchase Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };


    const handleUpdatePurchase = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            toast.error("Please fill all required fields correctly.");
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            // Build products array if purchaseType is Product
            const totals = formData.purchaseType === "Product"
                ? calculatePurchaseTotals(formData.products)
                : {
                    subtotal: Number(formData.subtotal || 0),
                    totalGST: Number(formData.purchaseGST || 0),
                    grandTotal: Number(formData.grandTotal || 0),
                    products: []
                };

            const updatedPurchaseData = {
                storeId: formData.storeId,
                purchaseDate: formData.purchaseDate,
                supplier: formData.supplier,
                supplierEmailAddress: formData.supplierEmailAddress,
                supplierPhoneNumber: formData.supplierPhoneNumber,
                purchaseType: formData.purchaseType,
                supplierId: formData.supplierId,
                products: totals.products.map(p => ({
                    productId: p.productId,
                    qty: Number(p.qty),
                    purchasePrice: Number(p.purchasePrice),
                    mrp: Number(p.mrp || p.sellingPrice || 0),
                    gstPercentage: Number(p.gstPercentage),
                    upc: p.upc || ""
                })),

                totalPurchaseAmount: totals.subtotal,
                purchaseGST: totals.totalGST,
                grandTotal: totals.grandTotal,
                payments: formData.payments.filter(p => p.method && p.amount).map(p => ({
                    method: p.method,
                    amount: Number(p.amount)
                })),
                paidNow: formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0),
                supplierInvoiceNumber: formData.supplierInvoiceNumber
            };


            console.log("Updating purchase with data:", updatedPurchaseData);

            const response = await putData(
                `purchase/purchase/${editPurchaseId}`,
                updatedPurchaseData,
                token
            );

            toast.success(response.message || "Purchase updated successfully");

            setFormData(prev => ({
                ...prev,
                payments: [{ method: "", amount: "" }]
            }));

            setIsPopupMode(false);
            setIsEditMode(false);
            fetchPurchase(currentPage, limit);
            triggerRefresh();

        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                "Error updating purchase"
            );
        } finally {
            setShowLoader(false);
        }
    };


    const handleDeletePurchase = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`purchase/purchase/${PurchaseToDelete}`, token);
            if (response && response.success === false) {
                toast.error(response.message || "Failed to delete Purchase");
                return;
            }
            toast.success(response?.message || "Purchase deleted successfully");
            setPurchaseToDelete(null);
            fetchPurchase(currentPage, limit, searchQuery, activeFilters, selectedStoreId);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error?.message || "Failed to delete Purchase");
        }
    };


    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    const fetchPurchase = async (page, limit, searchQuery, filters = {}) => {
        const params = {
            page,
            limit: limit === "all" ? 999999 : limit,
            search: searchQuery || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };
        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        if (filters.supplierId) params.supplierId = filters.supplierId;
        try {
            setLoading(true);
            const response = await getData('purchase/purchases', params, sessionToken); // Your API route
            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch Purchases");
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const purchaseList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setPurchases(purchaseList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Purchases");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [activeFilters]);

    useEffect(() => {
        fetchPurchase(currentPage, limit, searchQuery, activeFilters, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, activeFilters, selectedStoreId, sortField, sortOrder, store]);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const loadProducts = async (inputValue, loadedOptions, { page }) => {
        try {
            const sid = Array.isArray(formData.storeId) ? formData.storeId[0] : formData.storeId;
            const params = {
                page,
                limit: 100000,
                title: inputValue || "",
            };
            if (sid && sid.length === 24) {
                params.storeId = sid;
            }

            const res = await getData("products/products", params, token);
            const results = res?.data?.[0]?.paginatedResults || [];

            const options = results.map(product => ({
                value: product._id,
                label: product.title,
                fullData: product // we might need this for auto-fill
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Product Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const params = {};

                if (selectedStoreId) {
                    params.storeId = selectedStoreId;
                }

                const res = await getData("products/products", params, token);
                const products = res?.data?.[0]?.paginatedResults || [];
                setProducts(products);
            } catch {
                setProducts([]);
            }
        };
        fetchProducts();
    }, [selectedStoreId]);

    // Helper function to calculate grand total from products array
    const calculateGrandTotal = (products) => {
        return products.reduce((total, product) => {
            const qty = Number(product.qty) || 0;
            const purchasePrice = Number(product.purchasePrice) || 0;
            return total + (qty * purchasePrice);
        }, 0);
    };

    const calculatePurchaseTotals = (products = []) => {
        let subtotal = 0;
        let totalGST = 0;
        let grandTotal = 0;

        const updatedProducts = products.map(p => {
            const qty = Number(p.qty || 0);
            const price = Number(p.purchasePrice || 0);
            const gstPercent = Number(p.gstPercentage || 0);

            const lineTotal = qty * price;
            const gstAmount = (lineTotal * gstPercent) / (100 + gstPercent);
            const lineSubtotal = lineTotal - gstAmount;

            subtotal += lineSubtotal;
            totalGST += gstAmount;
            grandTotal += lineTotal;

            return {
                ...p,
                subtotal: Number(lineSubtotal.toFixed(2)),
                gstAmount: Number(gstAmount.toFixed(2)),
                lineTotal: Number(lineTotal.toFixed(2))
            };
        });

        return {
            products: updatedProducts,
            subtotal: Number(subtotal.toFixed(2)),
            totalGST: Number(totalGST.toFixed(2)),
            grandTotal: Number(grandTotal.toFixed(2))
        };
    };

    // Helper function to add a new product
    const addProduct = () => {
        setFormData((prev) => ({
            ...prev,
            products: [
                ...prev.products,
                {
                    productId: '',
                    productName: '',
                    upc: '',
                    gstPercentage: '',
                    gstAmount: '',
                    sellingPrice: '',
                    purchasePrice: '',
                    qty: '',
                    productImageObject: null
                }
            ]
        }));
    };

    // Helper function to remove a product
    const removeProduct = (index) => {
        setFormData((prev) => {
            const newProducts = prev.products.filter((_, i) => i !== index);
            const newGrandTotal = calculateGrandTotal(newProducts);
            return {
                ...prev,
                products: newProducts,
                grandTotal: newGrandTotal > 0 ? newGrandTotal.toFixed(2) : ""
            };
        });
    };

    const updateProduct = (index, field, value) => {
        setFormData((prev) => {
            const products = [...prev.products];
            const product = { ...products[index] };

            // Only convert numeric fields
            const numericFields = ["purchasePrice", "mrp", "qty", "gstPercentage"];

            product[field] = numericFields.includes(field)
                ? Number(value || 0)
                : value;

            const price = Number(product.purchasePrice || 0);
            const qty = Number(product.qty || 0);
            const gstPercentage = Number(product.gstPercentage || 0);

            const lineTotal = price * qty;
            const gstAmount = (lineTotal * gstPercentage) / (100 + gstPercentage);
            const subtotal = lineTotal - gstAmount;

            product.subtotal = subtotal;
            product.gstAmount = gstAmount;
            product.lineTotal = lineTotal;

            products[index] = product;

            const totals = calculatePurchaseTotals(products);

            return {
                ...prev,
                products,
                purchaseGST: totals.totalGST,
                grandTotal: totals.grandTotal
            };
        });
    };

    const addPayment = () => {
        setFormData(prev => ({
            ...prev,
            payments: [...prev.payments, { method: "", amount: "" }]
        }));
    };

    const removePayment = (index) => {
        setFormData(prev => {
            const payments = prev.payments.filter((_, i) => i !== index);
            return {
                ...prev,
                payments: payments.length > 0 ? payments : [{ method: "", amount: "" }]
            };
        });
    };

    const updatePayment = (index, field, value) => {
        setFormData(prev => {
            const payments = [...prev.payments];
            payments[index] = { ...payments[index], [field]: value };
            return { ...prev, payments };
        });
    };

    const handleNonProductTotalChange = (field, value) => {
        setFormData(prev => {
            const newData = { ...prev, [field]: value };
            const grandTotalVal = Number(newData.grandTotal || newData.subtotal || 0);
            const gstPercent = Number(newData.gstPercentage || 0);
            const gstAmount = (grandTotalVal * gstPercent) / (100 + gstPercent);
            const baseAmount = grandTotalVal - gstAmount;
            return {
                ...newData,
                subtotal: baseAmount.toFixed(2),
                purchaseGST: Number(gstAmount.toFixed(2)),
                grandTotal: grandTotalVal.toFixed(2)
            };
        });
    };

    const validateFields = (data) => {
        let newErrors = {};
        if (!data.storeId || (Array.isArray(data.storeId) && data.storeId.length === 0)) {
            newErrors.storeId = "Store is required";
        }
        if (!data.purchaseType) newErrors.purchaseType = "Purchase Type is required";
        if (!data.purchaseDate) newErrors.purchaseDate = "Purchase Date is required";
        if (!data.supplierId) newErrors.supplier = "Supplier is required";
        if (!data.supplierInvoiceNumber || !data.supplierInvoiceNumber.trim()) {
            newErrors.supplierInvoiceNumber = "Supplier Invoice Number is required";
        }

        // Validate products for Product purchases
        if (data.purchaseType === "Product") {
            if (!data.products || data.products.length === 0) {
                newErrors.products = "At least one product is required";
            } else {
                data.products.forEach((product, index) => {
                    if (!product.productId) {
                        newErrors[`productId_${index}`] = "Product is required";
                    }
                    if (!product.qty || product.qty === "") {
                        newErrors[`qty_${index}`] = "Quantity is required";
                    } else {
                        const qty = Number(product.qty);
                        if (isNaN(qty) || qty <= 0) {
                            newErrors[`qty_${index}`] = "Quantity must be greater than 0";
                        }
                    }
                    if (!product.purchasePrice || product.purchasePrice === "") {
                        newErrors[`purchasePrice_${index}`] = "Purchase Price is required";
                    } else {
                        const price = Number(product.purchasePrice);
                        if (isNaN(price) || price <= 0) {
                            newErrors[`purchasePrice_${index}`] = "Price must be greater than 0";
                        }
                    }
                });
            }
        } else if (data.purchaseType) {
            // For non-Product purchases
            if (!data.subtotal || data.subtotal === "") {
                newErrors.subtotal = "Amount is required";
            } else {
                const subtotal = Number(data.subtotal);
                if (isNaN(subtotal) || subtotal <= 0) {
                    newErrors.subtotal = "Amount must be greater than 0";
                }
            }
        }

        return newErrors;
    }

    // Initialize products array when purchaseType changes to "Product"
    useEffect(() => {
        if (formData.purchaseType === "Product" && formData.products.length === 0) {
            setFormData((prev) => ({
                ...prev,
                products: [{
                    productId: '',
                    productName: '',
                    upc: '',
                    gstPercentage: '',
                    gstAmount: '',
                    sellingPrice: '',
                    purchasePrice: '',
                    qty: '',
                    productImageObject: null
                }]
            }));
        } else if (formData.purchaseType !== "Product") {
            setFormData((prev) => ({
                ...prev,
                products: [],
                grandTotal: ""
            }));
        }
    }, [formData.purchaseType]);

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadSuppliers = async (inputValue, loadedOptions, { page }) => {
        try {
            const sid = Array.isArray(formData.storeId) ? formData.storeId[0] : formData.storeId;
            const params = {
                page,
                limit: 10,
                search: inputValue || "",
            };
            if (sid && sid.length === 24) {
                params.storeId = sid;
            }

            const res = await getData("suppliers/suppliers", params, token);
            if (res?.status !== 200) {
                toast.error(res?.message || "Failed to fetch Suppliers");
                return { options: [], hasMore: false };
            }

            // Fix API response extraction to match suppliersPage.jsx
            const resultsWrapper = res?.data?.[0] || {};
            const list = resultsWrapper?.paginatedResults || res?.data?.results || [];

            const options = list.map(supplier => ({
                value: supplier._id,
                label: supplier.supplierName,
                email: supplier.email,
                phone: supplier.phoneNumber
            }));

            return {
                options,
                hasMore: list.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Supplier Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const handleEditPurchase = async (purchaseId) => {
        try {
            const token = localStorage.getItem("Token");

            // ✅ FIXED API PATH
            const res = await getData(`purchase/purchase/${purchaseId}`, {}, token);
            const purchase = res?.data;

            if (!purchase) {
                console.error("No purchase data found");
                return;
            }

            const productsArray = purchase.products.map(p => {
                const pId = typeof p.productId === "object" ? p.productId?._id : (p.productId || "");
                const pName = typeof p.productId === "object" ? p.productId?.title : (p.productName || "");
                const pUpc = typeof p.productId === "object" ? p.productId?.upc : (p.upc || "");
                const mrpVal = p.mrp !== undefined && p.mrp !== null ? p.mrp : (typeof p.productId === "object" ? (p.productId?.sellingPrice || p.productId?.mrp) : (p.sellingPrice || 0));

                const qty = Number(p.qty || 0);
                const price = Number(p.purchasePrice || 0);
                const gstPercent = Number(p.gstPercentage || 0);

                const lineTotal = qty * price;
                const gstAmount = p.gstAmount !== undefined && p.gstAmount !== null
                    ? Number(p.gstAmount)
                    : Number(((lineTotal * gstPercent) / (100 + gstPercent)).toFixed(2));
                const lineSubtotal = lineTotal - gstAmount;

                return {
                    productId: pId || "",
                    productName: pName || "",
                    upc: pUpc || "",
                    qty: qty,
                    purchasePrice: price,
                    mrp: Number(mrpVal || 0),
                    gstPercentage: gstPercent,
                    gstAmount: gstAmount,
                    subtotal: Number(lineSubtotal.toFixed(2)),
                    lineTotal: Number(lineTotal.toFixed(2))
                };
            });

            setFormData({
                storeId: purchase.storeId?._id || purchase.store?.[0]?._id || purchase.storeId || "",
                storeName: purchase.storeId?.storeName || purchase.store?.[0]?.storeName || "",
                purchaseType: purchase.purchaseType,
                products: productsArray,

                supplierId: purchase.supplierId?._id || "",
                supplierName: purchase.supplierId?.supplierName || purchase.supplier?.[0]?.supplierName || purchase.supplierName || "",
                supplierEmailAddress: purchase.supplierEmailAddress || "",
                supplierPhoneNumber: purchase.supplierPhoneNumber || "",

                // ✅ ALWAYS STRING FOR <input type="date">
                purchaseDate: purchase.purchaseDate
                    ? purchase.purchaseDate.split("T")[0]
                    : "",

                grandTotal: Number(purchase.grandTotal),
                paidAmount: Number(purchase.paidAmount),
                payments: [{ method: "", amount: "" }],
                existingPayments: purchase.paymentLogs || [],

                supplierInvoiceNumber: purchase.supplierInvoiceNumber || "",
                subtotal: purchase.totalPurchaseAmount || "",
                purchaseGST: purchase.purchaseGST || 0,
                gstPercentage: purchase.purchaseType !== "Product" && purchase.products?.[0]?.gstPercentage
                    ? purchase.products[0].gstPercentage
                    : (purchase.purchaseGST && purchase.totalPurchaseAmount
                        ? Math.round(purchase.purchaseGST * 100 / purchase.totalPurchaseAmount)
                        : 0)
            });

            setEditpurchaseId(purchaseId);
            setIsEditMode(true);
            setIsPopupMode(true); // ✅ THIS OPENS POPUP

        } catch (error) {
            console.error("Edit Purchase Error:", error);
        }
    };


    const exportPurchasesToExcel = (purchases = []) => {
        if (!purchases.length) {
            alert("No data to export");
            return;
        }

        const rows = [];

        purchases.forEach(purchase => {
            const store = purchase.store?.[0];
            const supplier = purchase.supplier?.[0];

            purchase.products.forEach(item => {
                const product = purchase.product?.find(
                    p => p._id === item.productId
                );

                const lineTotal = item.lineTotal !== undefined && item.lineTotal !== null ? item.lineTotal : (item.purchasePrice * item.qty);
                const subtotal = lineTotal - (item.gstAmount || 0);

                rows.push({
                    "Purchase Date": new Date(purchase.purchaseDate).toLocaleDateString('en-GB'),
                    "Store Name": store?.storeName || "",
                    "Supplier Name": supplier?.supplierName || "",
                    "Supplier Phone": purchase.supplierPhoneNumber || "",
                    "Supplier Invoice No": purchase.supplierInvoiceNumber || "",

                    "Product Name": product?.title || "",
                    "UPC": product?.upc || "",

                    "Quantity": item.qty,
                    "Purchase Price": item.purchasePrice,
                    "GST %": item.gstPercentage,
                    "GST Amount": item.gstAmount,

                    "Subtotal": subtotal,
                    "Line Total": lineTotal,

                    "Grand Total (Purchase)": purchase.grandTotal,
                    "Paid Amount": purchase.paidAmount,
                    "Due Amount": purchase.dueAmount,
                    "Payment Status": purchase.paymentStatus
                });
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Purchases");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const blob = new Blob(
            [excelBuffer],
            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
        );

        saveAs(blob, `purchase-report-${Date.now()}.xlsx`);
    };

    const handleBulkUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const workbook = XLSX.read(evt.target.result, { type: "binary" });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                if (!rows.length) {
                    alert("Excel file is empty");
                    return;
                }

                // 🔹 Normalize + map Excel rows
                const uploadedProducts = rows.map((row) => {
                    const purchasePrice = Number(
                        row.purchasePrice ||
                        row["Purchase Price"] ||
                        0
                    );

                    const qty = Number(
                        row.qty ||
                        row.Qty ||
                        row.Quantity ||
                        1
                    );

                    const gstPercentage = Number(
                        row.gstPercentage ||
                        row["GST %"] ||
                        row.GST ||
                        0
                    );

                    return {
                        productId: "", // will be selected later
                        productName:
                            row.productName ||
                            row["Product Name"] ||
                            "",
                        upc:
                            row.upc ||
                            row.UPC ||
                            "",
                        purchasePrice,
                        qty,
                        gstPercentage
                    };
                });

                // 🔹 Merge with existing rows
                setFormData((prev) => {
                    const merged = [...prev.products, ...uploadedProducts];

                    // 🔹 IMPORTANT: calculate gst + totals
                    const totals = calculatePurchaseTotals(merged);

                    return {
                        ...prev,
                        products: totals.products,
                        grandTotal: totals.grandTotal
                    };
                });

            } catch (error) {
                console.error("Bulk upload error:", error);
                alert("Invalid Excel format");
            }
        };

        reader.readAsBinaryString(file);

        // 🔑 allow re-uploading same file
        e.target.value = "";
    };



    const downloadSampleExcel = () => {
        const sampleData = [
            {
                "Product Name": "Soap",
                "UPC": "1234567890",
                "Purchase Price": 50,
                "Qty": 10,
                "GST %": 18
            },
            {
                "Product Name": "Shampoo",
                "UPC": "9876543210",
                "Purchase Price": 120,
                "Qty": 5,
                "GST %": 12
            }
        ];

        const worksheet = XLSX.utils.json_to_sheet(sampleData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Products");

        XLSX.writeFile(workbook, "Bulk_Product_Upload_Template.xlsx");
    };


    const handlePurchaseDateChangeWithYearCheck = (value) => {
        if (!value) {
            setFormData(prev => ({ ...prev, purchaseDate: "" }));
            return;
        }

        // Expected format: YYYY-MM-DD
        const year = value.split("-")[0];

        if (year.length > 4) {
            toast.error("Year should contain only 4 digits");
            return; // 🚫 stop invalid update
        }

        setFormData(prev => ({
            ...prev,
            purchaseDate: value
        }));
    };



    return (
        <div className="purchase-layout1">
            <div className="purchase-content1">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader"><TVFMLoader /></div>
                    </div>
                )}
                <main className="purchase-main1">
                    {
                        isAddPurchase ? (
                            <div className="add-purchase-form">
                                <Typography variant="h6">Add Purchase</Typography>
                                <form className="Purchase-form" onSubmit={handleAddPurchase}>
                                    <div className="purchase-form-row">
                                        <div className="purchase-form-group">
                                            <label className="input-label">Store Name</label>
                                            <StoreMultiSelect
                                                value={
                                                    formData.storeId
                                                        ? [{
                                                            value: formData.storeId,
                                                            label: formData.storeName
                                                        }]
                                                        : []
                                                }
                                                onChange={(val) => {
                                                    // ❌ Prevent clearing if only one store
                                                    if (adminStoreIds.length === 1) return;

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        storeId: val?.[0]?.value || "",
                                                        storeName: val?.[0]?.label || "",

                                                    }));
                                                }}
                                                loadStores={loadStores}
                                                loggedInRole={role}
                                                assignedStoreIds={adminStoreIds}
                                                isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                            />
                                            {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                        </div>
                                        <div className="purchase-form-group">
                                            <label className="input-label">Purchase Type</label>
                                            <select
                                                id="purchaseType"
                                                className="purchase-input"
                                                value={formData.purchaseType}
                                                onChange={(e) => {
                                                    const selectedpurchaseType = e.target.value;
                                                    setFormData((prev) => ({ ...prev, purchaseType: selectedpurchaseType }))
                                                }}
                                            >
                                                <option value='Product'>Product</option>
                                            </select>
                                            {errors.purchaseType && <p className="field-error">{errors.purchaseType}</p>}
                                        </div>
                                        {/* ================= PRODUCTS TABLE ================= */}
                                        {formData.purchaseType === "Product" && (
                                            <>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: 12
                                                }}>
                                                    <h4>Products</h4>

                                                    <div style={{ display: "flex", gap: 10 }}>
                                                        <Button variant="outlined" onClick={addProduct}>
                                                            + Add Row
                                                        </Button>

                                                        <input
                                                            ref={bulkUploadRef}
                                                            type="file"
                                                            accept=".xlsx,.xls,.csv"
                                                            style={{ display: "none" }}
                                                            onChange={handleBulkUpload}
                                                        />

                                                        <label htmlFor="bulk-upload">
                                                            <Button
                                                                variant="outlined"
                                                                type="button"
                                                                onClick={() => bulkUploadRef.current.click()}
                                                            >
                                                                Bulk Upload
                                                            </Button>

                                                        </label>
                                                        <Button variant="outlined" onClick={downloadSampleExcel}>
                                                            Download Sample
                                                        </Button>

                                                    </div>
                                                </div>
                                                <Box component={Paper}>
                                                    {errors.products && (
                                                        <p className="field-error" style={{ color: "red", margin: "12px 16px", fontWeight: "500" }}>
                                                            {errors.products}
                                                        </p>
                                                    )}
                                                    <TableContainer component={Paper} sx={{
                                                        maxHeight: 300,          // 👈 shows ~5 rows
                                                        overflowY: "auto",
                                                        border: "1px solid #e0e0e0",
                                                        borderRadius: "8px",

                                                        // Optional: nice scrollbar
                                                        "&::-webkit-scrollbar": {
                                                            width: "6px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                            backgroundColor: "#c1c1c1",
                                                            borderRadius: "4px",
                                                        },
                                                    }}

                                                    >
                                                        <Table size="small">
                                                            <TableHead sx={{ bgcolor: "#3C0008" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Product</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>UPC</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Purchase Price</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>MRP</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Qty</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>GST %</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>GST Amount</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Line Total</TableCell>
                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {formData.products.map((product, index) => (
                                                                    <TableRow key={index}>
                                                                        {/* PRODUCT */}
                                                                        <TableCell sx={{ minWidth: 220, verticalAlign: "top" }}>
                                                                            <ProductSelect
                                                                                loadProducts={loadProducts}
                                                                                showAddProduct={false}

                                                                                /* 🔑 KEY FIX */
                                                                                value={
                                                                                    product.productId
                                                                                        ? {
                                                                                            value: product.productId,
                                                                                            label: product.productName
                                                                                        }
                                                                                        : product.productName
                                                                                            ? {
                                                                                                value: "__excel__",
                                                                                                label: product.productName
                                                                                            }
                                                                                            : null
                                                                                }

                                                                                onChange={(opt) => {
                                                                                    if (!opt) return;

                                                                                    const p = opt.fullData;

                                                                                    updateProduct(index, "productId", opt.value);
                                                                                    updateProduct(index, "productName", p.title);
                                                                                    updateProduct(index, "upc", p.upc);
                                                                                    updateProduct(index, "gstPercentage", p.gstPercentage || 0);
                                                                                    updateProduct(index, "purchasePrice", p.purchasePrice || 0);
                                                                                    updateProduct(index, "mrp", p.sellingPrice || p.mrp || 0);
                                                                                    updateProduct(index, "qty", 1);
                                                                                }}

                                                                                /* Optional UX hint */
                                                                                placeholder="Select Product"
                                                                            />
                                                                            {errors[`productId_${index}`] && (
                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                    {errors[`productId_${index}`]}
                                                                                </p>
                                                                            )}
                                                                        </TableCell>


                                                                        <TableCell sx={{ verticalAlign: "top", pt: 2 }}>{product.upc || "-"}</TableCell>

                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                            <input
                                                                                type="number"
                                                                                value={product.purchasePrice || ""}
                                                                                onChange={(e) =>
                                                                                    updateProduct(index, "purchasePrice", e.target.value)
                                                                                }
                                                                                className="purchase-input"
                                                                            />
                                                                            {errors[`purchasePrice_${index}`] && (
                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                    {errors[`purchasePrice_${index}`]}
                                                                                </p>
                                                                            )}
                                                                        </TableCell>

                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                            <input
                                                                                type="number"
                                                                                value={product.mrp ?? ""}
                                                                                onChange={(e) =>
                                                                                    updateProduct(index, "mrp", e.target.value)
                                                                                }
                                                                                className="purchase-input"
                                                                                placeholder="MRP"
                                                                            />
                                                                            {errors[`mrp_${index}`] && (
                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                    {errors[`mrp_${index}`]}
                                                                                </p>
                                                                            )}
                                                                        </TableCell>

                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                            <input
                                                                                type="number"
                                                                                min="1"
                                                                                value={product.qty || ""}
                                                                                onChange={(e) =>
                                                                                    updateProduct(index, "qty", e.target.value)
                                                                                }
                                                                                className="purchase-input"
                                                                            />
                                                                            {errors[`qty_${index}`] && (
                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                    {errors[`qty_${index}`]}
                                                                                </p>
                                                                            )}
                                                                        </TableCell>

                                                                        <TableCell>
                                                                            <select
                                                                                className="purchase-input"
                                                                                value={product.gstPercentage || 0}
                                                                                onChange={(e) => updateProduct(index, "gstPercentage", e.target.value)}
                                                                            >
                                                                                <option value={0}>0%</option>
                                                                                <option value={5}>5%</option>
                                                                                <option value={12}>12%</option>
                                                                                <option value={18}>18%</option>
                                                                                {product.gstPercentage && ![0, 5, 12, 18].includes(Number(product.gstPercentage)) && (
                                                                                    <option value={product.gstPercentage}>{product.gstPercentage}%</option>
                                                                                )}
                                                                            </select>
                                                                        </TableCell>

                                                                        <TableCell>
                                                                            ₹{Number(product.gstAmount || 0).toFixed(2)}
                                                                        </TableCell>

                                                                        <TableCell>
                                                                            ₹{Number(product.lineTotal || 0).toFixed(2)}
                                                                        </TableCell>

                                                                        <TableCell>
                                                                            <Icon
                                                                                icon={deleteIcon}
                                                                                width={18}
                                                                                style={{ cursor: "pointer", color: "#C10000" }}
                                                                                onClick={() => removeProduct(index)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                                {formData.products.length === 0 && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={8} align="center">
                                                                            No products added
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>

                                            </>
                                        )}
                                    </div>
                                    <div className="purchase-form-row">
                                        <div className="purchase-form-group">
                                            <label className="input-label">Supplier</label>
                                            <SupplierSelect
                                                key={`${formData.storeId}-${supplierRefreshKey}`}
                                                loadSuppliers={loadSuppliers}
                                                value={
                                                    formData.supplierId
                                                        ? {
                                                            value: formData.supplierId,
                                                            label: formData.supplierName,
                                                            email: formData.supplierEmailAddress,
                                                            phone: formData.supplierPhoneNumber,
                                                        }
                                                        : null
                                                }
                                                onAddSupplier={() => setIsAddSupplier(true)}
                                                onChange={(selectedOption) => {
                                                    if (!selectedOption) return;

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        supplierId: selectedOption.value,
                                                        supplierName: selectedOption.label,
                                                        supplierEmailAddress: selectedOption.email || "",
                                                        supplierPhoneNumber: selectedOption.phone || "",
                                                    }));
                                                }}
                                                formatOptionLabel={(option, { context }) => {
                                                    if (option.value === "__ADD_SUPPLIER__") return option.label;
                                                    if (context === "menu") {
                                                        return (
                                                            <div>
                                                                <div style={{ fontWeight: 'bold' }}>{option.label}</div>
                                                                <div style={{ fontSize: '12px', color: '#666' }}>
                                                                    {option.phone ? `Ph: ${option.phone}` : ''}
                                                                    {option.email ? ` | ${option.email}` : ''}
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    return option.label;
                                                }}
                                            />

                                            {errors.supplier && <p className="field-error">{errors.supplier}</p>}
                                        </div>
                                        <div className="purchase-form-group">
                                            <label className="input-label">Supplier Email Address</label>
                                            <input
                                                type="text"
                                                className="purchase-input"
                                                value={formData.supplierEmailAddress}
                                                onChange={e => {
                                                    const value = e.target.value;

                                                    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                                        setErrors(prev => ({ ...prev, supplierEmailAddress: "Enter a valid email address" }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, supplierEmailAddress: "" }));
                                                    }

                                                    setFormData(prev => ({ ...prev, supplierEmailAddress: value }));
                                                }}
                                            />

                                            {errors.supplierEmailAddress && (
                                                <p className="supplierEmailAddress" style={{ color: "red" }}>{errors.supplierEmailAddress}</p>
                                            )}
                                        </div>
                                        <div className="purchase-form-group">
                                            <label className="input-label">Supplier Phone Number</label>
                                            <input
                                                type="Number"
                                                className="purchase-input"
                                                value={formData.supplierPhoneNumber || ""}
                                                onChange={e => {
                                                    const value = e.target.value;

                                                    if (value && !/^[6-9]\d{9}$/.test(value)) {
                                                        setErrors(prev => ({ ...prev, supplierPhoneNumber: "Enter a valid 10-digit mobile number" }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, supplierPhoneNumber: "" }));
                                                    }

                                                    setFormData(prev => ({ ...prev, supplierPhoneNumber: value }));
                                                }}
                                            />

                                            {errors.supplierPhoneNumber && (
                                                <p className="supplierPhoneNumber" style={{ color: "red" }}>{errors.supplierPhoneNumber}</p>
                                            )}
                                        </div>
                                        <div className="purchase-form-group">
                                            <label className="input-label">Date Of Purchase</label>
                                            <input
                                                type="date"
                                                className="purchase-input"
                                                value={formData.purchaseDate || ""}
                                                onChange={(e) =>
                                                    handlePurchaseDateChangeWithYearCheck(e.target.value)
                                                }
                                            />

                                            {errors.purchaseDate && <p className="field-error">{errors.purchaseDate}</p>}
                                        </div>
                                    </div>

                                    {formData.purchaseType !== "Product" && (
                                        <div className="purchase-form-row">
                                            <div className="purchase-form-group">
                                                <label className="input-label">Amount (Excl. GST)</label>
                                                <input
                                                    type="number"
                                                    className="purchase-input"
                                                    value={formData.subtotal || ""}
                                                    onChange={(e) => handleNonProductTotalChange("subtotal", e.target.value)}
                                                />
                                                {errors.subtotal && <p className="field-error">{errors.subtotal}</p>}
                                            </div>
                                            <div className="purchase-form-group">
                                                <label className="input-label">GST (%)</label>
                                                <select
                                                    className="purchase-input"
                                                    value={formData.gstPercentage || 0}
                                                    onChange={(e) => handleNonProductTotalChange("gstPercentage", e.target.value)}
                                                >
                                                    <option value={0}>0%</option>
                                                    <option value={5}>5%</option>
                                                    <option value={12}>12%</option>
                                                    <option value={18}>18%</option>
                                                </select>
                                            </div>
                                            <div className="purchase-form-group">
                                                <label className="input-label">GST Amount</label>
                                                <input
                                                    type="number"
                                                    className="purchase-input"
                                                    value={Number(formData.purchaseGST || 0).toFixed(2)}
                                                    readOnly
                                                    style={{ backgroundColor: '#f0f0f0' }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="purchase-form-row">
                                        <div className="purchase-form-group">
                                            <label className="input-label">Grand Total (Auto-calculated)</label>
                                            <input
                                                type="number"
                                                className="purchase-input"
                                                value={formData.grandTotal || ""}
                                                readOnly
                                                style={{ backgroundColor: '#f0f0f0' }}
                                            />
                                        </div>
                                        <div className="purchase-form-group">
                                            <label className="input-label">Supplier Invoice Number</label>
                                            <input
                                                type="text"
                                                className="purchase-input"
                                                value={formData.supplierInvoiceNumber || ""}
                                                onChange={e => setFormData(prev => ({ ...prev, supplierInvoiceNumber: e.target.value }))}
                                            />
                                            {errors.supplierInvoiceNumber && <p className="field-error">{errors.supplierInvoiceNumber}</p>}
                                        </div>
                                    </div>

                                    {/* Payment Logs Section for Add Form */}
                                    <div style={{ marginTop: '20px', borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <h4 style={{ margin: 0 }}>Payment Logs</h4>
                                            <Button variant="outlined" size="small" onClick={(e) => { e.preventDefault(); addPayment(); }}>
                                                + Add Payment
                                            </Button>
                                        </div>

                                        {formData.payments.map((p, idx) => (
                                            <div key={idx} className="form-group-row" style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
                                                <div className="form-group" style={{ flex: 2 }}>
                                                    <label className="input-label">Payment Method</label>
                                                    <select
                                                        className="purchase-input"
                                                        value={p.method}
                                                        onChange={(e) => updatePayment(idx, "method", e.target.value)}
                                                    >
                                                        <option value="">Select Method</option>
                                                        <option value="CASH">CASH</option>
                                                        <option value="UPI">UPI</option>
                                                        <option value="CARD">CARD</option>
                                                        <option value="OTHERS">OTHERS</option>
                                                    </select>
                                                </div>
                                                <div className="form-group" style={{ flex: 2 }}>
                                                    <label className="input-label">Amount</label>
                                                    <input
                                                        type="number"
                                                        className="purchase-input"
                                                        placeholder="Amount"
                                                        value={p.amount}
                                                        onChange={(e) => updatePayment(idx, "amount", e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group" style={{ flex: 0.5, marginBottom: '5px' }}>
                                                    <Icon
                                                        icon={deleteIcon}
                                                        width={24}
                                                        style={{ cursor: "pointer", color: "#C10000" }}
                                                        onClick={() => removePayment(idx)}
                                                    />
                                                </div>
                                            </div>
                                        ))}

                                        {/* Total Paid Display for Add Form */}
                                        <div style={{ textAlign: 'right', marginTop: '10px', fontWeight: 600 }}>
                                            Total Paid: ₹{formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0).toFixed(2)}
                                        </div>
                                    </div>
                                    {formData.products.length > 0 && (() => {
                                        const totals = calculatePurchaseTotals(formData.products);

                                        return (
                                            <div style={{
                                                marginTop: '20px',
                                                padding: '16px',
                                                background: '#f9f9f9',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd'
                                            }}>
                                                <div><strong>Subtotal:</strong> ₹{totals.subtotal}</div>
                                                <div><strong>Total GST:</strong> ₹{totals.totalGST}</div>
                                                <div style={{ fontSize: '18px', fontWeight: 700 }}>
                                                    Grand Total: ₹{totals.grandTotal}
                                                </div>
                                            </div>
                                        );
                                    })()}

                                    <div className="Purchase-buttons">
                                        <button className="add-Product-button" type="submit" onClick={handleAddPurchase}>
                                            Add Purchase
                                        </button>
                                        <button className="cancel-Product-button" onClick={() => setIsAddPurchase(false)}>
                                            cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <>
                                <div className="product-widgets">
                                    <div className="product-widgets-header">
                                        <Typography variant="h6">Purchases</Typography>
                                        {/* <input
                                            type="text"
                                            placeholder="Search"
                                            className="Purchase-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        /> */}
                                    </div>

                                    {["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) && (
                                        <StoreSingleAllStoresSelect
                                            value={store}
                                            onChange={
                                                (store) => {
                                                    setStore(store)
                                                }
                                            }
                                        />
                                    )}
                                    {/* Desktop View: Keep original side-by-side array */}
                                    <div className="add-product-buttons desktop-only">
                                        <button
                                            type="button"
                                            className="add-Product-button"
                                            onClick={() => exportPurchasesToExcel(purchases)}
                                        >
                                            Export Purchases
                                        </button>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <button className="add-Product-button" onClick={() => setIsAddPurchase(true)} >+ Add Purchase</button>
                                            <button style={{ marginLeft: '12px' }} className="add-Product-button" onClick={() => setShowFilter(!showFilter)}>{showFilter ? 'Hide Filter' : 'Show Filter'}</button>
                                        </div>
                                    </div>

                                    {/* Mobile View: Actions Dropdown + Add Purchase */}
                                    <div className="add-product-buttons mobile-only">
                                        <button className="add-Product-button" onClick={() => setIsAddPurchase(true)}>+ Add Purchase</button>

                                        <button
                                            className="add-Product-button dropdown-trigger"
                                            onClick={handleActionClick}
                                            style={{
                                                background: '#f8fafc',
                                                color: '#3C0008',
                                                border: '1px solid #3C0008',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            }}
                                        >
                                            <Icon icon="mdi:tune" width="18" /> Actions
                                        </button>

                                        <Menu
                                            anchorEl={actionAnchorEl}
                                            open={isActionMenuOpen}
                                            onClose={handleActionClose}
                                            PaperProps={{
                                                sx: {
                                                    borderRadius: '12px',
                                                    mt: 1,
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                    border: '1px solid #e2e8f0',
                                                    '& .MuiMenuItem-root': {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem
                                                onClick={() => {
                                                    handleActionClose();
                                                    exportPurchasesToExcel(purchases);
                                                }}
                                                sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                            >
                                                <Icon icon="mdi:export" style={{ fontSize: '18px', color: '#64748b' }} />
                                                Export Purchases
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    handleActionClose();
                                                    setShowFilter(!showFilter);
                                                }}
                                                sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                            >
                                                <Icon icon={showFilter ? "mdi:eye-off" : "mdi:eye"} style={{ fontSize: '18px', color: '#64748b' }} />
                                                {showFilter ? 'Hide Filter' : 'Show Filter'}
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </div>
                                {showFilter && (
                                    <PurchaseHeader onApplyFilters={(newFilters) => {
                                        setActiveFilters(newFilters);
                                    }} />
                                )}
                                <Box>
                                    <TableContainer component={Paper} sx={{
                                        maxHeight: 400,
                                        overflowY: "auto",
                                        '&::-webkit-scrollbar': { display: 'none' },
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none',
                                    }}>
                                        <Table className="custom-product-table"
                                            sx={{
                                                '& td, & th': {
                                                    border: 'none',
                                                },
                                                border: 'none',
                                            }}>
                                            <TableHead className="custom-product-head">
                                                <TableRow>
                                                    {headings.map((heading, index) => {
                                                        const isPurchaseDate = heading === "Date";
                                                        const isSupplier = heading === "Supplier";
                                                        const isGrandTotal = heading === "Grand Total";
                                                        const isPaid = heading === "Paid";
                                                        const isDue = heading === "Due";
                                                        const isPaymentStatus = heading === "Payment Status"
                                                        const sortKey = isPurchaseDate
                                                            ? "purchaseDate"
                                                            : isSupplier
                                                                ? "supplier"
                                                                : isGrandTotal
                                                                    ? "grandTotal"
                                                                    : isPaid
                                                                        ? "paidAmount"
                                                                        : isDue
                                                                            ? "dueAmount"
                                                                            : isPaymentStatus
                                                                                ? "paymentStatus"
                                                                                : null;

                                                        return (
                                                            <TableCell
                                                                key={index}
                                                                sx={{
                                                                    border: "none",
                                                                    padding: "12px 16px",
                                                                    textAlign: "center",
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    zIndex: 10,
                                                                    backgroundColor: "#3C0008",
                                                                    minWidth: heading === "Payment Status" ? "140px" : heading === "Date" ? "100px" : "auto",
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "4px",
                                                                        color: "#ffffff",
                                                                        fontSize: "14px",
                                                                        fontWeight: 600,
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    {heading}
                                                                    {sortKey && (
                                                                        <span
                                                                            onClick={() => handleSort(sortKey)}
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                color: "#fff",
                                                                                cursor: "pointer",
                                                                                marginLeft: "4px",
                                                                                userSelect: "none",
                                                                            }}
                                                                        >
                                                                            {sortField === sortKey
                                                                                ? sortOrder === 1
                                                                                    ? "▲"
                                                                                    : "▼"
                                                                                : "▲▼"}
                                                                        </span>
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>

                                            </TableHead>
                                            <TableBody>
                                                {purchases.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={headings.length}>
                                                            <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                                No purchases found.
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    purchases.map((purchase, index) => (
                                                        <TableRow key={purchase._id}>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {purchase.purchaseDate
                                                                        ? DateTime.fromISO(purchase.purchaseDate).toFormat("dd/MM/yyyy")
                                                                        : "—"}
                                                                </Typography>

                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {purchase.supplier?.[0]?.supplierName || "—"}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {Array.isArray(purchase.products) ? purchase.products.length : 0}
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {purchase.grandTotal}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {purchase.paidAmount}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {purchase.dueAmount}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ minWidth: "140px", textAlign: "center" }}>
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: '#3c0008',
                                                                        color: '#fff',
                                                                        fontWeight: 500,
                                                                        padding: '4px 8px',
                                                                        borderRadius: '20px',
                                                                        width: '90px',
                                                                        maxHeight: '70px',
                                                                        fontSize: '12px',
                                                                        textTransform: 'none',
                                                                        '&:hover': {
                                                                            backgroundColor: '#3c0008',
                                                                            boxShadow: 'none',
                                                                        },
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        margin: '0 auto',
                                                                        boxShadow: 'none',
                                                                    }}
                                                                >
                                                                    {purchase.paymentStatus}
                                                                </Button>
                                                            </TableCell>

                                                            <TableCell sx={{ minWidth: "120px", textAlign: "center" }}>
                                                                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                    {/* <Icon icon={plusIcon} width={20} height={20} /> */}
                                                                    <Tooltip title="View Purchase ">
                                                                        <Icon
                                                                            icon={plusIcon}
                                                                            width={20}
                                                                            height={20}
                                                                            style={{ cursor: "pointer", color: "#666" }}
                                                                            onClick={() => handleViewPurchase(purchase._id)}
                                                                            title="View Purchase Details"
                                                                        />
                                                                    </Tooltip>
                                                                    <Tooltip title="Edit Purchase">
                                                                        <Icon
                                                                            icon={editIcon}
                                                                            width={20}
                                                                            height={20}
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleEditPurchase(purchase._id);
                                                                            }}
                                                                        />
                                                                    </Tooltip>

                                                                    {role !== "SelfAdmin" && role !== "Accountant" && (
                                                                        <Tooltip title="Delete Purchase">
                                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                                onClick={() => handleOpen(purchase._id)}
                                                                            />
                                                                        </Tooltip>
                                                                    )}

                                                                </Box>

                                                            </TableCell>
                                                        </TableRow>

                                                    ))
                                                )}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <div className="purchase-bottom">
                                        <div className="purchase-section show-entries">
                                            <span className="text-label">Show</span>
                                            <select className="entries-select" value={limit}
                                                onChange={handleItemsPerPageChange}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="all">All</option>
                                            </select>
                                            <span className="text-label">Entries</span>
                                        </div>
                                        <div className="purchase-section showing-range">
                                            {
                                                limit === 'all'
                                                    ? `Showing all ${totalCount} entries`
                                                    : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                            }
                                        </div>
                                        <div className="purchase-section spacer"></div>
                                        <div className="purchase-section pagination-buttons">
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("first")}
                                            ><Icon icon="mdi:chevron-double-left" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("prev")}
                                            ><Icon icon="mdi:chevron-left" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("next")}
                                            ><Icon icon="mdi:chevron-right" /></button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("last")}
                                            ><Icon icon="mdi:chevron-double-right" /></button>
                                        </div>
                                    </div>
                                </Box>

                                {
                                    isPopupMode && (
                                        <div className='popup-overlay'>
                                            <div className="popup-wrapper">
                                                <Icon
                                                    icon={closeIcon}
                                                    className="popup-close-icon-outside"
                                                    onClick={() => {
                                                        setIsPopupMode(false);
                                                        setIsEditMode(false);
                                                        setLoaderText("");
                                                        setFormData({
                                                            purchaseType: "Product",
                                                            products: [],
                                                            purchaseDate: "",
                                                            supplier: "",
                                                            supplierPhoneNumber: "",
                                                            supplierEmailAddress: "",
                                                            grandTotal: "",
                                                            paidAmount: "",
                                                            payments: [{ method: "", amount: "" }],
                                                            storeId: initialStoreId,
                                                        });
                                                    }}
                                                />
                                                <div className="popup-form">
                                                    <h2 className="popup-title">
                                                        {isEditMode ? "Edit Purchase" : "Add Purchase"}
                                                    </h2>
                                                    <div className='purchase-form-container'></div>
                                                    <form className="popup-form-body" onSubmit={handleUpdatePurchase}>

                                                        {/* ===================== ROW 1 ===================== */}
                                                        <div className="form-group-row">

                                                            {/* Branch Name */}
                                                            <div className="form-group">
                                                                <label className="input-label">Store Name</label>
                                                                <StoreMultiSelect
                                                                    value={
                                                                        formData.storeId
                                                                            ? (Array.isArray(formData.storeId)
                                                                                ? formData.storeId.map((id, i) => ({
                                                                                    value: id,
                                                                                    label: Array.isArray(formData.storeName) ? formData.storeName[i] : formData.storeName
                                                                                }))
                                                                                : [{ value: formData.storeId, label: formData.storeName }]
                                                                            )
                                                                            : []
                                                                    }
                                                                    onChange={(val) => {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            storeId: val.map(v => v.value),
                                                                            storeName: val.map(v => v.label),
                                                                        }));
                                                                    }}
                                                                    loadStores={loadStores}
                                                                    loggedInRole={role}
                                                                    assignedStoreIds={adminStoreIds}
                                                                    onAddStore={() => setIsAddStore(true)}
                                                                />
                                                                {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                            </div>

                                                            {/* Purchase Type */}
                                                            <div className="form-group">
                                                                <label className="input-label">Purchase Type</label>
                                                                <select
                                                                    className="purchase-input"
                                                                    value={formData.purchaseType}
                                                                    required
                                                                    onChange={(e) => {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            purchaseType: e.target.value
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="Product">Product</option>
                                                                </select>
                                                                {errors.purchaseType && <p className="field-error">{errors.purchaseType}</p>}
                                                            </div>

                                                        </div>
                                                        {formData.purchaseType === "Product" && (
                                                            <>
                                                                <div style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    marginBottom: 12
                                                                }}>
                                                                    <h4>Products</h4>

                                                                    <div style={{ display: "flex", gap: 10 }}>
                                                                        <Button variant="outlined" onClick={addProduct}>
                                                                            + Add Row
                                                                        </Button>

                                                                        <input
                                                                            ref={bulkUploadRef}
                                                                            type="file"
                                                                            accept=".xlsx,.xls,.csv"
                                                                            style={{ display: "none" }}
                                                                            onChange={handleBulkUpload}
                                                                        />

                                                                        <label htmlFor="bulk-upload">
                                                                            <Button
                                                                                variant="outlined"
                                                                                type="button"
                                                                                onClick={() => bulkUploadRef.current.click()}
                                                                            >
                                                                                Bulk Upload
                                                                            </Button>

                                                                        </label>
                                                                        <Button variant="outlined" onClick={downloadSampleExcel}>
                                                                            Download Sample
                                                                        </Button>

                                                                    </div>
                                                                </div>
                                                                <Box component={Paper}>
                                                                    {errors.products && (
                                                                        <p className="field-error" style={{ color: "red", margin: "12px 16px", fontWeight: "500" }}>
                                                                            {errors.products}
                                                                        </p>
                                                                    )}
                                                                    <TableContainer component={Paper} sx={{
                                                                        maxHeight: 300,          // 👈 shows ~5 rows
                                                                        overflowY: "auto",
                                                                        border: "1px solid #e0e0e0",
                                                                        borderRadius: "8px",
                                                                        marginBottom: "2px",
                                                                        // Optional: nice scrollbar
                                                                        "&::-webkit-scrollbar": {
                                                                            width: "6px",
                                                                        },
                                                                        "&::-webkit-scrollbar-thumb": {
                                                                            backgroundColor: "#c1c1c1",
                                                                            borderRadius: "4px",
                                                                        },
                                                                    }}

                                                                    >
                                                                        <Table size="small">
                                                                            <TableHead sx={{ bgcolor: "#3C0008" }}>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Product</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>UPC</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Purchase Price</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>MRP</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Qty</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>GST %</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>GST Amount</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Line Total</TableCell>
                                                                                    <TableCell sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center", backgroundColor: "#3C0008" }}>Action</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {formData.products.map((product, index) => (
                                                                                    <TableRow key={index}>
                                                                                        {/* PRODUCT */}
                                                                                        <TableCell sx={{ minWidth: 220, verticalAlign: "top" }}>
                                                                                            <ProductSelect
                                                                                                loadProducts={loadProducts}
                                                                                                showAddProduct={false}

                                                                                                /* 🔑 KEY FIX */
                                                                                                value={
                                                                                                    product.productId
                                                                                                        ? {
                                                                                                            value: product.productId,
                                                                                                            label: product.productName || "Selected Product"
                                                                                                        }
                                                                                                        : product.productName
                                                                                                            ? {
                                                                                                                value: "__excel__",
                                                                                                                label: product.productName
                                                                                                            }
                                                                                                            : null
                                                                                                }


                                                                                                onChange={(opt) => {
                                                                                                    if (!opt) return;

                                                                                                    const p = opt.fullData;

                                                                                                    updateProduct(index, "productId", opt.value);
                                                                                                    updateProduct(index, "productName", p.title);
                                                                                                    updateProduct(index, "upc", p.upc);
                                                                                                    updateProduct(index, "gstPercentage", p.gstPercentage || 0);
                                                                                                    updateProduct(index, "purchasePrice", p.purchasePrice || 0);
                                                                                                    updateProduct(index, "mrp", p.sellingPrice || p.mrp || 0);
                                                                                                    updateProduct(index, "qty", 1);
                                                                                                }}

                                                                                                /* Optional UX hint */
                                                                                                placeholder="Select Product"
                                                                                            />
                                                                                            {errors[`productId_${index}`] && (
                                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                                    {errors[`productId_${index}`]}
                                                                                                </p>
                                                                                            )}
                                                                                        </TableCell>


                                                                                        <TableCell sx={{ verticalAlign: "top", pt: 2 }}>{product.upc || "-"}</TableCell>

                                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                                            <input
                                                                                                type="number"
                                                                                                value={product.purchasePrice || ""}
                                                                                                onChange={(e) =>
                                                                                                    updateProduct(index, "purchasePrice", e.target.value)
                                                                                                }
                                                                                                className="purchase-input"
                                                                                            />
                                                                                            {errors[`purchasePrice_${index}`] && (
                                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                                    {errors[`purchasePrice_${index}`]}
                                                                                                </p>
                                                                                            )}
                                                                                        </TableCell>

                                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                                            <input
                                                                                                type="number"
                                                                                                value={product.mrp ?? ""}
                                                                                                onChange={(e) =>
                                                                                                    updateProduct(index, "mrp", e.target.value)
                                                                                                }
                                                                                                className="purchase-input"
                                                                                                placeholder="MRP"
                                                                                            />
                                                                                            {errors[`mrp_${index}`] && (
                                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                                    {errors[`mrp_${index}`]}
                                                                                                </p>
                                                                                            )}
                                                                                        </TableCell>

                                                                                        <TableCell sx={{ verticalAlign: "top" }}>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={product.qty || ""}
                                                                                                onChange={(e) =>
                                                                                                    updateProduct(index, "qty", e.target.value)
                                                                                                }
                                                                                                className="purchase-input"
                                                                                            />
                                                                                            {errors[`qty_${index}`] && (
                                                                                                <p className="field-error" style={{ color: "red", fontSize: "11px", marginTop: "4px", margin: 0 }}>
                                                                                                    {errors[`qty_${index}`]}
                                                                                                </p>
                                                                                            )}
                                                                                        </TableCell>

                                                                                        <TableCell>
                                                                                            <select
                                                                                                className="purchase-input"
                                                                                                value={product.gstPercentage || 0}
                                                                                                onChange={(e) => updateProduct(index, "gstPercentage", e.target.value)}
                                                                                            >
                                                                                                <option value={0}>0%</option>
                                                                                                <option value={5}>5%</option>
                                                                                                <option value={12}>12%</option>
                                                                                                <option value={18}>18%</option>
                                                                                                {product.gstPercentage && ![0, 5, 12, 18].includes(Number(product.gstPercentage)) && (
                                                                                                    <option value={product.gstPercentage}>{product.gstPercentage}%</option>
                                                                                                )}
                                                                                            </select>
                                                                                        </TableCell>

                                                                                        <TableCell>
                                                                                            ₹{Number(product.gstAmount || 0).toFixed(2)}
                                                                                        </TableCell>

                                                                                        <TableCell>
                                                                                            ₹{Number(product.lineTotal || 0).toFixed(2)}
                                                                                        </TableCell>

                                                                                        <TableCell>
                                                                                            <Icon
                                                                                                icon={deleteIcon}
                                                                                                width={18}
                                                                                                style={{ cursor: "pointer", color: "#C10000" }}
                                                                                                onClick={() => removeProduct(index)}
                                                                                            />
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))}

                                                                                {formData.products.length === 0 && (
                                                                                    <TableRow>
                                                                                        <TableCell colSpan={8} align="center">
                                                                                            No products added
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>

                                                            </>
                                                        )}


                                                        <div className="form-group-row">

                                                            <div className="form-group">
                                                                <label className="input-label">Supplier</label>
                                                                <SupplierSelect
                                                                    key={`${formData.storeId}-${supplierRefreshKey}`}
                                                                    loadSuppliers={loadSuppliers}
                                                                    value={
                                                                        formData.supplierId
                                                                            ? {
                                                                                value: formData.supplierId,
                                                                                label: formData.supplierName,
                                                                                email: formData.supplierEmailAddress,
                                                                                phone: formData.supplierPhoneNumber,
                                                                            }
                                                                            : null
                                                                    }
                                                                    onAddSupplier={() => setIsAddSupplier(true)}
                                                                    onChange={(selectedOption) => {
                                                                        if (!selectedOption) return;

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            supplierId: selectedOption.value,            // ✅ FIX
                                                                            supplierName: selectedOption.label,           // ✅ FIX
                                                                            supplierEmailAddress: selectedOption.email || "",
                                                                            supplierPhoneNumber: selectedOption.phone || "",
                                                                        }));
                                                                    }}
                                                                />
                                                                {errors.supplier && <p className="field-error">{errors.supplier}</p>}
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="input-label">Supplier Email</label>
                                                                <input
                                                                    type="text"
                                                                    className="purchase-input"
                                                                    value={formData.supplierEmailAddress || ""}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                                                                            setErrors(prev => ({
                                                                                ...prev,
                                                                                supplierEmailAddress: "Enter valid email"
                                                                            }));
                                                                        } else {
                                                                            setErrors(prev => ({ ...prev, supplierEmailAddress: "" }));
                                                                        }
                                                                        setFormData(prev => ({ ...prev, supplierEmailAddress: val }));
                                                                    }}
                                                                />
                                                                {errors.supplierEmailAddress && (
                                                                    <p className="text-red-500 text-sm">{errors.supplierEmailAddress}</p>
                                                                )}
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="input-label">Supplier Phone</label>
                                                                <input
                                                                    type="number"
                                                                    className="purchase-input"
                                                                    value={formData.supplierPhoneNumber || ""}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (val && !/^[6-9]\d{9}$/.test(val)) {
                                                                            setErrors(prev => ({
                                                                                ...prev,
                                                                                supplierPhoneNumber: "Enter valid mobile number"
                                                                            }));
                                                                        } else {
                                                                            setErrors(prev => ({ ...prev, supplierPhoneNumber: "" }));
                                                                        }
                                                                        setFormData(prev => ({ ...prev, supplierPhoneNumber: val }));
                                                                    }}
                                                                />
                                                                {errors.supplierPhoneNumber && (
                                                                    <p className="text-red-500 text-sm">{errors.supplierPhoneNumber}</p>
                                                                )}
                                                            </div>

                                                        </div>

                                                        <div className="form-group-row">

                                                            <div className="form-group">
                                                                <label className="input-label">Date of purchase</label>
                                                                <input
                                                                    type="date"
                                                                    className="purchase-input"
                                                                    value={formData.purchaseDate || ""}
                                                                    onChange={(e) =>
                                                                        handlePurchaseDateChangeWithYearCheck(e.target.value)
                                                                    }
                                                                />
                                                                {errors.purchaseDate && <p className="field-error">{errors.purchaseDate}</p>}

                                                            </div>

                                                            {formData.purchaseType !== "Product" && (
                                                                <>
                                                                    <div className="form-group">
                                                                        <label className="input-label">Amount (Excl. GST)</label>
                                                                        <input
                                                                            type="number"
                                                                            className="purchase-input"
                                                                            value={formData.subtotal || ""}
                                                                            onChange={(e) => handleNonProductTotalChange("subtotal", e.target.value)}
                                                                        />
                                                                        {errors.subtotal && <p className="field-error">{errors.subtotal}</p>}
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="input-label">GST (%)</label>
                                                                        <select
                                                                            className="purchase-input"
                                                                            value={formData.gstPercentage || 0}
                                                                            onChange={(e) => handleNonProductTotalChange("gstPercentage", e.target.value)}
                                                                        >
                                                                            <option value={0}>0%</option>
                                                                            <option value={5}>5%</option>
                                                                            <option value={12}>12%</option>
                                                                            <option value={18}>18%</option>
                                                                        </select>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </div>

                                                        <div className="form-group-row">
                                                            <div className="form-group">
                                                                <label className="input-label">Grand Total (Auto-calculated)</label>
                                                                <input
                                                                    type="number"
                                                                    className="purchase-input"
                                                                    value={formData.grandTotal || ""}
                                                                    readOnly
                                                                    style={{ backgroundColor: '#f0f0f0' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="input-label">Already Paid</label>
                                                                <input
                                                                    type="number"
                                                                    className="purchase-input"
                                                                    value={formData.paidAmount || 0}
                                                                    disabled
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="input-label">Supplier Invoice Number</label>
                                                                <input
                                                                    type="text"
                                                                    className="purchase-input"
                                                                    value={formData.supplierInvoiceNumber || ""}
                                                                    onChange={e => setFormData(prev => ({ ...prev, supplierInvoiceNumber: e.target.value }))}
                                                                />
                                                                {errors.supplierInvoiceNumber && <p className="field-error">{errors.supplierInvoiceNumber}</p>}
                                                            </div>
                                                        </div>

                                                        {/* Historical Payment Logs Table */}
                                                        {formData.existingPayments && formData.existingPayments.length > 0 && (
                                                            <div style={{ marginTop: '20px' }}>
                                                                <h4 style={{ marginBottom: '10px' }}>Payment Logs</h4>
                                                                <TableContainer component={Paper} sx={{ maxHeight: 200, overflowY: 'auto' }}>
                                                                    <Table size="small">
                                                                        <TableHead sx={{ bgcolor: "#3C0008" }}>
                                                                            <TableRow>
                                                                                <TableCell sx={{ color: "#ffffff", fontWeight: 600, backgroundColor: "#3C0008" }}>Method</TableCell>
                                                                                <TableCell sx={{ color: "#ffffff", fontWeight: 600, backgroundColor: "#3C0008" }}>Amount</TableCell>
                                                                                <TableCell sx={{ color: "#ffffff", fontWeight: 600, backgroundColor: "#3C0008" }}>Date</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {formData.existingPayments.map((pay, pIdx) => (
                                                                                <TableRow key={pIdx}>
                                                                                    <TableCell>{pay.method}</TableCell>
                                                                                    <TableCell>₹{Number(pay.amount || 0).toFixed(2)}</TableCell>
                                                                                    <TableCell>
                                                                                        {pay.paidAt ? DateTime.fromISO(pay.paidAt).toFormat("dd/MM/yyyy") : "-"}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </div>
                                                        )}

                                                        {/* Payment Logs Section (To add NEW payments) */}
                                                        <div style={{ marginTop: '20px', borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                                <h4 style={{ margin: 0, color: '#3C0008', fontWeight: 700 }}>Pay Now (Add New Payment)</h4>
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={(e) => { e.preventDefault(); addPayment(); }}
                                                                    sx={{ color: '#3C0008', borderColor: '#3C0008', '&:hover': { borderColor: '#a52a2a', color: '#a52a2a' } }}
                                                                >
                                                                    + Add Payment
                                                                </Button>
                                                            </div>

                                                            {formData.payments.map((p, idx) => (
                                                                <div key={idx} className="form-group-row" style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
                                                                    <div className="form-group" style={{ flex: 2 }}>
                                                                        <label className="input-label">Payment Method</label>
                                                                        <select
                                                                            className="purchase-input"
                                                                            value={p.method}
                                                                            onChange={(e) => updatePayment(idx, "method", e.target.value)}
                                                                        >
                                                                            <option value="">Select Method</option>
                                                                            <option value="CASH">Cash</option>
                                                                            <option value="UPI">UPI</option>
                                                                            <option value="CARD">Card</option>
                                                                            <option value="OTHERS">Others</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="form-group" style={{ flex: 2 }}>
                                                                        <label className="input-label">Amount</label>
                                                                        <input
                                                                            type="number"
                                                                            className="purchase-input"
                                                                            placeholder="Amount"
                                                                            value={p.amount}
                                                                            onChange={(e) => updatePayment(idx, "amount", e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group" style={{ flex: 0.5, marginBottom: '5px' }}>
                                                                        <Icon
                                                                            icon={deleteIcon}
                                                                            width={24}
                                                                            style={{ cursor: "pointer", color: "#C10000" }}
                                                                            onClick={() => removePayment(idx)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {/* Consolidated Financial Summary for Edit Form */}
                                                            <div style={{
                                                                marginTop: '20px',
                                                                padding: '15px',
                                                                backgroundColor: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                border: '1px solid #dee2e6',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '8px'
                                                            }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span style={{ color: '#6c757d' }}>Total Purchase Amount:</span>
                                                                    <span style={{ fontWeight: 600 }}>₹{Number(formData.grandTotal || 0).toFixed(2)}</span>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span style={{ color: '#6c757d' }}>Already Paid (Past):</span>
                                                                    <span style={{ fontWeight: 600, color: '#28a745' }}>₹{Number(formData.paidAmount || 0).toFixed(2)}</span>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span style={{ color: '#6c757d' }}>Want to Paid (Now):</span>
                                                                    <span style={{ fontWeight: 600, color: '#007bff' }}>₹{formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0).toFixed(2)}</span>
                                                                </div>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    marginTop: '8px',
                                                                    paddingTop: '8px',
                                                                    borderTop: '2px solid #e9ecef',
                                                                    fontSize: '16px'
                                                                }}>
                                                                    <span style={{ fontWeight: 700 }}>Remaining Due:</span>
                                                                    <span style={{
                                                                        fontWeight: 700,
                                                                        color: (Number(formData.grandTotal || 0) - Number(formData.paidAmount || 0) - formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0)) > 0 ? '#dc3545' : '#28a745'
                                                                    }}>
                                                                        ₹{(Number(formData.grandTotal || 0) - Number(formData.paidAmount || 0) - formData.payments.reduce((acc, p) => acc + Number(p.amount || 0), 0)).toFixed(2)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-actions">
                                                            <button type="submit" className="add-Product-button">
                                                                Update Purchase
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="cancel-Product-button"
                                                                onClick={() => setIsPopupMode(false)}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>

                                                    </form>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {limit > 5 && purchases.length > 5 && (
                                    <div className="scroll-down-hint">
                                        <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                            Scroll down to see more purchases
                                        </Typography>
                                    </div>
                                )}
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                >
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: 380,
                                            background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                            borderRadius: "20px",
                                            boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                            p: 4,
                                            outline: "none",
                                            textAlign: "center",
                                            overflow: "hidden"
                                        }}
                                    >
                                        {/* ✅ TOP ICON BADGE */}
                                        <Box
                                            sx={{
                                                width: 74,
                                                height: 74,
                                                borderRadius: "50%",
                                                background: "#3C0008",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto 16px auto",
                                                color: "#fff",
                                                fontSize: 30,

                                                boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                                animation: "deletePulse 1.6s infinite ease-in-out",

                                                "@keyframes deletePulse": {
                                                    "0%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                    },
                                                    "70%": {
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                    },
                                                    "100%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                    },
                                                },
                                            }}
                                        >
                                            🗑️
                                        </Box>


                                        {/* ✅ TITLE */}
                                        <Typography
                                            id="modal-modal-title"
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                color: "#2b2b2b",
                                                letterSpacing: "0.3px"
                                            }}
                                        >
                                            Confirm Delete
                                        </Typography>

                                        {/* ✅ DESCRIPTION */}
                                        <Typography
                                            id="modal-modal-description"
                                            sx={{
                                                mt: 1.2,
                                                fontSize: 14,
                                                color: "#666",
                                                lineHeight: 1.6
                                            }}
                                        >
                                            Are you sure you want to delete this purchase?
                                        </Typography>

                                        {/* ✅ BUTTON GROUP */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: 2.5,
                                                mt: 3.5
                                            }}
                                        >
                                            {/* ✅ DELETE BUTTON */}
                                            <Button
                                                variant="contained"
                                                className="add-Product-button"
                                                onClick={handleDeletePurchase}
                                            >
                                                Yes, Delete
                                            </Button>

                                            {/* ✅ CANCEL BUTTON */}
                                            <Button
                                                variant="outlined"
                                                onClick={handleClose}
                                                className="cancel-Product-button"
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>

                                {/* ✅ PAYMENT LOGS POPUP */}
                                <Modal
                                    open={isViewLogsPopup}
                                    onClose={() => setIsViewLogsPopup(false)}
                                    aria-labelledby="payment-logs-title"
                                    aria-describedby="payment-logs-description"
                                >
                                    <Box
                                        sx={{
                                            ...modalStyle,
                                            width: 600,
                                            bgcolor: 'white',
                                            p: 0,
                                            overflow: 'hidden',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        {/* Header */}
                                        <Box sx={{
                                            p: 2.5,
                                            background: '#3C0008',
                                            color: 'white',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                            <Typography id="payment-logs-title" variant="h6" fontWeight={700}>
                                                Payment History
                                            </Typography>
                                            <Icon
                                                icon={closeIcon}
                                                width={24}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setIsViewLogsPopup(false)}
                                            />
                                        </Box>

                                        {/* Content */}
                                        <Box sx={{ p: 3, flex: 1, overflowY: 'auto' }}>
                                            {viewLogsData && (
                                                <>
                                                    <Box sx={{ mb: 3, p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #eee' }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                            <Typography variant="body2" color="textSecondary">Supplier</Typography>
                                                            <Typography variant="body2" fontWeight={600}>{viewLogsData.supplierId?.supplierName || viewLogsData.supplierName || "-"}</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <Typography variant="body2" color="textSecondary">Purchase Date</Typography>
                                                            <Typography variant="body2" fontWeight={600}>
                                                                {viewLogsData.purchaseDate ? DateTime.fromISO(viewLogsData.purchaseDate).toFormat("dd/MM/yyyy") : "-"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee' }}>
                                                        <Table size="small">
                                                            <TableHead sx={{ bgcolor: '#3C0008' }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ color: 'white', fontWeight: 600 }}>Date</TableCell>
                                                                    <TableCell sx={{ color: 'white', fontWeight: 600 }}>Method</TableCell>
                                                                    <TableCell sx={{ color: 'white', fontWeight: 600 }} align="right">Amount</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {viewLogsData.paymentLogs && viewLogsData.paymentLogs.length > 0 ? (
                                                                    viewLogsData.paymentLogs.map((p, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell>
                                                                                {p.paidAt ? DateTime.fromISO(p.paidAt).toFormat("dd/MM/yyyy") : "-"}
                                                                            </TableCell>
                                                                            <TableCell>{p.method}</TableCell>
                                                                            <TableCell align="right">₹{Number(p.amount || 0).toFixed(2)}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={3} align="center" sx={{ py: 3, color: '#999' }}>
                                                                            No payment records found
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                    <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                                                        <Box sx={{ display: 'flex', gap: 4 }}>
                                                            <Typography variant="body2" color="textSecondary">Total Amount:</Typography>
                                                            <Typography variant="body2" fontWeight={600} sx={{ minWidth: 80 }} align="right">
                                                                ₹{Number(viewLogsData.grandTotal || 0).toFixed(2)}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', gap: 4 }}>
                                                            <Typography variant="body2" color="textSecondary">Total Paid:</Typography>
                                                            <Typography variant="body2" fontWeight={700} color="#28A745" sx={{ minWidth: 80 }} align="right">
                                                                ₹{Number(viewLogsData.paidAmount || 0).toFixed(2)}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', gap: 4, mt: 0.5, pt: 0.5, borderTop: '1px solid #eee' }}>
                                                            <Typography variant="body2" color="textSecondary">Balance Due:</Typography>
                                                            <Typography variant="body2" fontWeight={700} color="#C10000" sx={{ minWidth: 80 }} align="right">
                                                                ₹{(Number(viewLogsData.grandTotal || 0) - Number(viewLogsData.paidAmount || 0)).toFixed(2)}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </>
                                            )}
                                        </Box>

                                        {/* Footer */}
                                        <Box sx={{ p: 2, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => setIsViewLogsPopup(false)}
                                                sx={{
                                                    background: '#3C0008',
                                                    '&:hover': { background: '#a52a2a' }
                                                }}
                                            >
                                                Close
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>

                                {/* ✅ VIEW PURCHASE DETAILS POPUP */}
                                <Modal
                                    open={isViewPurchasePopup}
                                    onClose={() => setIsViewPurchasePopup(false)}
                                    aria-labelledby="view-purchase-title"
                                >
                                    <Box
                                        sx={{
                                            ...modalStyle,
                                            width: 800,
                                            maxWidth: '90vw',
                                            bgcolor: 'white',
                                            p: 0,
                                            overflow: 'hidden',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        {/* Header */}
                                        <Box sx={{
                                            p: 2.5,
                                            background: '#3C0008',
                                            color: 'white',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                            <Typography id="view-purchase-title" variant="h6" fontWeight={700}>
                                                Purchase Details
                                            </Typography>
                                            <Icon
                                                icon={closeIcon}
                                                width={24}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setIsViewPurchasePopup(false)}
                                            />
                                        </Box>

                                        {/* Content */}
                                        <Box sx={{ p: 3, flex: 1, overflowY: 'auto', maxHeight: '70vh' }}>
                                            {viewPurchaseData && (
                                                <>
                                                    <Box sx={{ mb: 3, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #eee' }}>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Store Name</Typography>
                                                            <Typography variant="body2" fontWeight={600}>
                                                                {viewPurchaseData.store?.[0]?.storeName || viewPurchaseData.storeId?.storeName || viewPurchaseData.storeName || "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Supplier</Typography>
                                                            <Typography variant="body2" fontWeight={600}>
                                                                {viewPurchaseData.supplierId?.supplierName || viewPurchaseData.supplier?.[0]?.supplierName || viewPurchaseData.supplierName || "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Purchase Date</Typography>
                                                            <Typography variant="body2" fontWeight={600}>
                                                                {viewPurchaseData.purchaseDate ? DateTime.fromISO(viewPurchaseData.purchaseDate).toFormat("dd/MM/yyyy") : "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Invoice Number</Typography>
                                                            <Typography variant="body2" fontWeight={600}>{viewPurchaseData.supplierInvoiceNumber || "-"}</Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Purchase Type</Typography>
                                                            <Typography variant="body2" fontWeight={600}>{viewPurchaseData.purchaseType || "-"}</Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" color="textSecondary">Created At</Typography>
                                                            <Typography variant="body2" fontWeight={600}>
                                                                {viewPurchaseData.createdAt ? DateTime.fromISO(viewPurchaseData.createdAt).toFormat("dd/MM/yyyy HH:mm") : "-"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Typography variant="subtitle2" gutterBottom fontWeight={700}>Products / Items</Typography>
                                                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
                                                        <Table size="small">
                                                            <TableHead sx={{ bgcolor: '#3C0008' }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }}>Product</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }}>UPC</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">Qty</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">Price</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">GST %</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">GST Amt</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">Total</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {viewPurchaseData.products && viewPurchaseData.products.length > 0 ? (
                                                                    viewPurchaseData.products.map((p, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell>{p.productId?.title || p.productName || "-"}</TableCell>
                                                                            <TableCell>{p.productId?.upc || p.upc || "-"}</TableCell>
                                                                            <TableCell align="right">{p.qty}</TableCell>
                                                                            <TableCell align="right">₹{Number(p.purchasePrice || 0).toFixed(2)}</TableCell>
                                                                            <TableCell align="right">{p.gstPercentage}%</TableCell>
                                                                            <TableCell align="right">₹{Number(p.gstAmount || 0).toFixed(2)}</TableCell>
                                                                            <TableCell align="right">₹{(p.lineTotal !== undefined && p.lineTotal !== null ? Number(p.lineTotal) : Number(p.qty || 0) * Number(p.purchasePrice || 0)).toFixed(2)}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={7} align="center" sx={{ py: 2 }}>No products listed</TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                    <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                                                        {/* Payment History Section */}
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography variant="subtitle2" gutterBottom fontWeight={700}>Payment History</Typography>
                                                            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee' }}>
                                                                <Table size="small">
                                                                    <TableHead sx={{ bgcolor: '#3C0008' }}>
                                                                        <TableRow>
                                                                            <TableCell sx={{ fontWeight: 600, color: '#fff' }}>Date</TableCell>
                                                                            <TableCell sx={{ fontWeight: 600, color: '#fff' }}>Method</TableCell>
                                                                            <TableCell sx={{ fontWeight: 600, color: '#fff' }} align="right">Amount</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {viewPurchaseData.paymentLogs && viewPurchaseData.paymentLogs.length > 0 ? (
                                                                            viewPurchaseData.paymentLogs.map((p, idx) => (
                                                                                <TableRow key={idx}>
                                                                                    <TableCell>
                                                                                        {p.paidAt ? DateTime.fromISO(p.paidAt).toFormat("dd/MM/yyyy") : "-"}
                                                                                    </TableCell>
                                                                                    <TableCell>{p.method}</TableCell>
                                                                                    <TableCell align="right">₹{Number(p.amount || 0).toFixed(2)}</TableCell>
                                                                                </TableRow>
                                                                            ))
                                                                        ) : (
                                                                            <TableRow>
                                                                                <TableCell colSpan={3} align="center" sx={{ py: 2, color: '#999' }}>No payments found</TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Box>

                                                        {/* Financial Summary */}
                                                        <Box sx={{ width: 280, p: 2, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #eee' }}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                                <Typography variant="body2" color="textSecondary">Subtotal:</Typography>
                                                                <Typography variant="body2" fontWeight={600}>₹{Number(viewPurchaseData.totalPurchaseAmount || 0).toFixed(2)}</Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                                <Typography variant="body2" color="textSecondary">Total GST:</Typography>
                                                                <Typography variant="body2" fontWeight={600}>₹{Number(viewPurchaseData.purchaseGST || 0).toFixed(2)}</Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1.5, pt: 1.5, borderTop: '2px solid #ddd', mb: 1 }}>
                                                                <Typography variant="subtitle2" fontWeight={700}>Grand Total:</Typography>
                                                                <Typography variant="subtitle2" fontWeight={700} color="primary">₹{Number(viewPurchaseData.grandTotal || 0).toFixed(2)}</Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                                <Typography variant="body2" color="textSecondary">Paid Amount:</Typography>
                                                                <Typography variant="body2" fontWeight={600} color="#28A745">₹{Number(viewPurchaseData.paidAmount || 0).toFixed(2)}</Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <Typography variant="body2" fontWeight={700} color="#C10000">Balance Due:</Typography>
                                                                <Typography variant="body2" fontWeight={700} color="#C10000">₹{Number(viewPurchaseData.dueAmount || 0).toFixed(2)}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </>
                                            )}
                                        </Box>

                                        {/* Footer */}
                                        <Box sx={{ p: 2, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => setIsViewPurchasePopup(false)}
                                                sx={{
                                                    background: '#3C0008',
                                                    '&:hover': { background: '#3C0008' }
                                                }}
                                            >
                                                Close
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>

                            </>
                        )
                    }
                </main>
            </div >
            {
                isAddStore && (
                    <div className="popup-overlay">
                        <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                            <Icon
                                icon={closeIcon}
                                className="popup-close-icon-outside"
                                onClick={() => setIsAddStore(false)}
                            />
                            <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                <AddStoreForm
                                    onSuccess={() => {
                                        setIsAddStore(false);
                                        setStoreRefreshKey(prev => prev + 1);
                                    }}
                                    onCancel={() => setIsAddStore(false)}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isAddProduct && (
                    <div className="popup-overlay">
                        <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                            <Icon
                                icon={closeIcon}
                                className="popup-close-icon-outside"
                                onClick={() => setIsAddProduct(false)}
                            />
                            <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                <AddProductForm
                                    onSuccess={() => {
                                        setIsAddProduct(false);
                                        setProductRefreshKey(prev => prev + 1);
                                    }}
                                    onCancel={() => setIsAddProduct(false)}
                                    initialStoreId={formData.storeId}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isAddSupplier && (
                    <div className="popup-overlay">
                        <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                            <Icon
                                icon={closeIcon}
                                className="popup-close-icon-outside"
                                onClick={() => setIsAddSupplier(false)}
                            />
                            <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                <AddSupplierForm
                                    onSuccess={(newSupplier) => {
                                        setIsAddSupplier(false);
                                        setSupplierRefreshKey(prev => prev + 1);
                                        setFormData(prev => ({
                                            ...prev,
                                            supplierId: newSupplier?._id || "",
                                            supplier: newSupplier?.supplierName || "",
                                            supplierEmailAddress: newSupplier?.email || "",
                                            supplierPhoneNumber: newSupplier?.phoneNumber || "",
                                        }));
                                    }}
                                    onCancel={() => setIsAddSupplier(false)}
                                    initialStoreId={formData.storeId}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
            <Footer />
        </div >
    );
};

export default PurchasePage;